export const AUTH = "AUTH";
export const AUTH_FAIL = "AUTH_FAIL";
export const GET_BUSINESSEMAIL = "GET_BUSINESSEMAIL";
export const LOGOUT = "LOGOUT";
export const GET_LOCATIONS = "GET_LOCATIONS";
export const SET_LOCATIONS = "SET_LOCATIONS";
export const GET_STAFF = "GET_STAFF";
export const GET_CURRENCY = "GET_CURRENCY";
export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS";
export const ADD_TO_CART_PRODUCTS = "ADD_TO_CART_PRODUCTS";
export const GET_ALL_CUSTOMERS_REQUEST = "GET_ALL_CUSTOMERS_REQUEST";
export const GET_ALL_CUSTOMERS = "GET_ALL_CUSTOMERS";
export const GET_ALL_CUSTOMERS_FAILED = "GET_ALL_CUSTOMERS_FAILED";
export const GET_ALL_DISCOUNT = "GET_ALL_DISCOUNT";
export const GET_TRANSACTION_REQUEST = "GET_TRANSACTION_REQUEST";
export const GET_TRANSACTION = "GET_TRANSACTION";
export const GET_TRANSACTION_FAILED = "GET_TRANSACTION_FAILED";
export const GET_TRANSACTION_ANALYTICS = "GET_TRANSACTION_ANALYTICS";
export const APPLY_DISCOUNT = "APPLY_DISCOUNT";
export const PLACE_ORDER = "PLACE_ORDER";
export const PLACE_ORDER_REQUEST = "PLACE_ORDER_REQUEST";
export const PLACE_ORDER_FAILED = "PLACE_ORDER_FAILED";
export const SEND_INVOICE_REQUEST = "SEND_INVOICE_REQUEST";
export const SEND_INVOICE = "SEND_INVOICE";
export const SEND_INVOICE_FAILED = "SEND_INVOICE_FAILED";
export const RETURN_PRODUCT_REQUEST = "RETURN_PRODUCT_REQUEST";
export const RETURN_PRODUCT = "RETURN_PRODUCT";
export const RETURN_PRODUCT_FAILED = "RETURN_PRODUCT_FAILED";
export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const UPDATE_PRODUCT_FAILED = "UPDATE_PRODUCT_FAILED";
export const HANDLE_ERROR = "HANDLE_ERROR";